import { UserImageContainer } from '@anm/components/SocialAvatar';
import Tooltip from '@anm/components/Tooltip';
import { flexCenter, media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const DestinationItem = styled.div``;

export const TooltipText = styled.span`
  color: #fff;
  font-size: 14px;
`;

export const DestinationTooltip = styled(Tooltip)`
  min-width: 220px;
  padding: 12px 16px;
  transform: translate(40%, calc(-100% - 10px));
  &:before {
    left: 49%;
  }
`;

const mobileWrapper = media.phone`
  padding-right: 10px;
`;

export const DestinationsWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-right: 20px;
  margin-right: auto;

  ${UserImageContainer} {
    flex-shrink: 0;
    margin-right: 4px;
  }

  ${mobileWrapper};
`;

export const AdditionalSign = styled.div`
  width: 30px;
  height: 30px;
  ${flexCenter};
  font-size: 14px;
  font-weight: 700;
  border-radius: 50%;
  color: var(--gray_900);
  border: 1px solid rgba(0, 56, 87, 0.2);
`;
